"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeName = function (obj) {
    var name = obj.name || (obj.constructor && obj.constructor.name);
    if (name && name.includes('Error')) {
        return "_error." + name.replace('Error', '').toLowerCase();
    }
    return name;
};
//# sourceMappingURL=sanitize-name.js.map